import * as React from 'react';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import {
	TermItem,
	useLazyTermItemsQuery,
} from '../../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useState } from 'react';
import useTranslation from '../../../../../Hooks/useTranslation';
import AsyncSelect from '../../../../../Components/Base/Select/AsyncSelect';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
}

const HealthCareRegulationCaseTypeSelect: React.FC<Props> = ({
	onChange,
	value,
}) => {
	const { t } = useTranslation();
	const [getTermItems] = useLazyTermItemsQuery();

	const [searchTimeout, setSearchTimeout] = useState<any>(undefined);

	const loadOptions = (
		inputValue: string,
		callback: (options: SelectValue[]) => void,
	) => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const loadData = async () => {
			const { termItems } = await getTermItems({
				termType: 'health_care_regulation_case_type',
				fullText: inputValue,
				take: 10,
			}).unwrap();

			const t: SelectValue[] = [];

			// @ts-ignore
			(termItems?.data || []).forEach((termItem: TermItem) => {
				if (termItem.name) {
					t.push({
						value: termItem.id,
						label: termItem.name,
					});
				}
			});

			callback(t);
		};

		setSearchTimeout(
			setTimeout(() => {
				loadData();
			}, 500),
		);
	};

	const handleChange = (val: SelectValue) => {
		onChange?.(val);
	};

	return (
		<AsyncSelect
			onSearch={loadOptions}
			onChange={handleChange}
			placeholder={t('base.shared.pick')}
			noOptionsMessage={t('base.startTyping')}
			value={value}
		/>
	);
};

export default HealthCareRegulationCaseTypeSelect;
